import { all, fork } from 'redux-saga/effects'

import addToQueue from './addToQueue'
import shiftFirst from './shiftFirst'

export function* offlineSaga() {
  yield all([fork(addToQueue), fork(shiftFirst)])
}
